import React from 'react';

import styles from './b2b-hero.module.scss';
import Image from 'next/image';
import classNames from 'classnames';
import { Category, IMAGE_POSITIONS_CATEGORY } from '@/types/Category';
import { BuilderContentType } from '@/types/Builder';
import { B2BCategory } from '../b2b-category/b2b-category';
import { Button } from '@builder.io/react';

export interface Props {
    categories?: {
        category: BuilderContentType<Category>;
    }[];
    articleCategories?: Category[];
    subTitle?: string;
    title?: string;
    fontSizeTitle?: 'LARGE' | 'SMALL';
    useLargeTitle?: boolean;
    description?: string;
    titleMaxWidth?: number;
    descriptionMaxWidth?: number;
    textColor?: string;
    background?: string;
    position?: IMAGE_POSITIONS_CATEGORY;
    backgroundImage?: {
        desktop?: string;
        mobile?: string;
    };

    button?: {
        name: string;
        url: string;
    };
}

const B2BHero = (props: Props) => {
    const {
        background,
        textColor,
        subTitle,
        title,
        useLargeTitle,
        description,
        titleMaxWidth,
        descriptionMaxWidth,
        backgroundImage,
        articleCategories = [],
        button,
        position,
    } = props;

    return (
        <div
            className={classNames(styles.container, { [styles.article]: articleCategories.length > 0 })}
            style={{
                color: textColor,
            }}
        >
            <div
                className={styles.background}
                style={{
                    backgroundColor: background,
                }}
            >
                <div className={styles.image}>
                    {backgroundImage?.desktop && (
                        <Image
                            className={classNames({ [styles.desktop]: !!backgroundImage.mobile })}
                            src={backgroundImage.desktop}
                            alt=""
                            loading={'lazy'}
                            fill
                            style={{ objectFit: 'cover', objectPosition: position }}
                            loader={({ src, width, quality }) => {
                                return `${src}?width=${width}&quality=${quality ?? 75}`;
                            }}
                        />
                    )}
                    {backgroundImage?.mobile && (
                        <Image
                            className={classNames({ [styles.mobile]: !!backgroundImage.desktop })}
                            src={backgroundImage.mobile}
                            alt=""
                            loading={'lazy'}
                            fill
                            style={{ objectFit: 'cover', objectPosition: 'center' }}
                            loader={({ src, width, quality }) => {
                                return `${src}?width=${width}&quality=${quality ?? 75}`;
                            }}
                        />
                    )}
                </div>
            </div>
            <div className={styles.content}>
                {articleCategories.length ? <B2BCategory categories={articleCategories} className={styles.categories} theme="light" /> : null}
                {subTitle ? <div className={styles.subTitle} dangerouslySetInnerHTML={{ __html: subTitle }}></div> : null}
                {title ? (
                    <div
                        className={classNames(styles.title, { [styles.large]: useLargeTitle })}
                        dangerouslySetInnerHTML={{ __html: title }}
                        style={{ maxWidth: titleMaxWidth }}
                    ></div>
                ) : null}
                {description ? <div className={styles.description} style={{ maxWidth: descriptionMaxWidth }} dangerouslySetInnerHTML={{ __html: description }}></div> : null}
                {button?.url || button?.name ? (
                    <a href={button?.url} className={styles.button}>
                        <span className={styles.text}>{button?.name || 'sign up'}</span>
                    </a>
                ) : null}
            </div>
        </div>
    );
};

export default B2BHero;
